


















import {Component, Vue} from 'vue-property-decorator';
import CancelPopup from '@/views/claim/popup/CancelPopup.vue'
import ExchangePopup from '@/views/claim/popup/ExchangePopup.vue'
import ReturnPopup from '@/views/claim/popup/ReturnPopup.vue'
import {GetClaimsNo} from 'supporter';
import {ClaimType} from '@/types/claim';

@Component({
  components: {
    CancelPopup,
    ExchangePopup,
    ReturnPopup,
  }
})
export default class ViewPopup extends Vue{
  private claimType:string = '';
  private claimNoResponseData: GetClaimsNo = {} as any // as GetClaimsNo시 린트 에러발생
  private isResult: string = ''; // TODO: bolean 문자열 쿼리인데, 기존 레거시 의도 파악 필요
  private orderProductOptionNo: string = '';
  private deliveryCompleteYmdt: string = '';

  created(){
    this.fetchAndSetClaimData();
  }

  private async getShippingOptions(shippingNo: number) {
    const { data } = await this.$api.getShippingsOptions({ params: { shippingNo } });
    this.deliveryCompleteYmdt = data.orderOptions[0].status.deliveryCompleteYmdt;
  }

  async fetchAndSetClaimData(): Promise<void>{
    try{
      const {data} = await this.$api.getClaimsNo({pathParams: {no: this.$route.query.claimNo.toString()}})
      data.originalPayType === 'RENTAL' && await this.getShippingOptions(data.claimData.shipping.shippingNo);
      this.setClaimData(data)
    }catch(error){
      const NO_RESOURCE = 'E1006';
      if (error?.data?.code && error.data.code === NO_RESOURCE){
        this.$router.push({name: 'ClaimNotFound'})
      }
    }
  }

  setClaimData(claimNoResponseData: GetClaimsNo): void{
    this.claimNoResponseData = claimNoResponseData
    this.claimType = claimNoResponseData.claimType as ClaimType
    this.isResult = this.$route.query.isResult.toString()
    this.orderProductOptionNo = this.$route.query.orderProductOptionNo.toString()
  }
}
